export default __webpack_public_path__ + "static/speed-dark-1f75fd1e11d8f42c0a5585b77d77a061.png";